import React from 'react';
import IconBase, { IconColor, IconSize } from './IconBase';

export type IconTrash2Props = {
    color?: IconColor;
    size?: IconSize;
    className?: string;
    title?: string;
};

const IconTrash2: React.FC<IconTrash2Props> = ({
    color = 'primary',
    size = 'md',
    className = '',
    title = 'Delete',
}) => (
    <IconBase color={color} size={size} className={className} title={title}>
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M10 11v6" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M14 11v6" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M3 6h18" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    </IconBase>
);

export default IconTrash2;
